import { render, staticRenderFns } from "./leftBottom.vue?vue&type=template&id=6bee7b7e&scoped=true"
import script from "./leftBottom.vue?vue&type=script&lang=js"
export * from "./leftBottom.vue?vue&type=script&lang=js"
import style0 from "./leftBottom.vue?vue&type=style&index=0&id=6bee7b7e&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bee7b7e",
  null
  
)

export default component.exports